import { useEffect, useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import SaleTableRow from "./sale-table-row";
import { Sale } from "../../../../service/model/store.model";
import { configs } from "../../../../app/app-configs";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { fetchSales, selectTotalPages } from "../sale.slice";

const headers: ColumnHeader[] = [
    { name: "Sale Date" },
    { name: "Total Amount" },
    { name: "Items" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly sales: Sale[]
}

const SaleTable: React.FC<TableProps> = ({ sales }) => {
    const dispatch = useAppDispatch();
    const [page, setPage] = useState(1);
    const totalPages = useAppSelector(selectTotalPages);

    useEffect(() => {
        dispatch(fetchSales({
            pagination: { page: page - 1, size: configs.PAGE_SIZE },
            name: "",
            from: "",
            to: ""
        }))
    }, [page]);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={totalPages}
            onPageChange={handlePageChange}>

            {sales?.map(sale =>
                <SaleTableRow sale={sale} key={sale.id} />
            )}
        </StyledTable>
    );
}

export default SaleTable;